module.exports = __webpack_public_path__ + "static/media/terms.7544478d.svg";